import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { FormFieldsContainer } from '../../../components/Form/FormComponents';
import { FormFactoryWithStandardLayout } from '../../../components/Form/FormFactory';
import { StickyFormButtons } from '../../../components/Form/StickyFormButtons';
import {
  fromMissVMToDealDM,
  PassDealFormViewModel,
  useMissDealFormVMSchema,
} from '../../../schemas/deal.schema';
import { schemaToFormFields } from '../../../util/schema-utils';
import { createFormFromFieldsArray } from '../../../view-models/form.view-model';
import { useDealActions2 } from '../hooks/useDealActions';
import { IDealActionFormProps } from './PassDealForm';

export function MissDealForm({ deal, onClose, next }: IDealActionFormProps) {
  const schema = useMissDealFormVMSchema();
  const { handleMissed } = useDealActions2();
  const [loading, setLoading] = useState(false);

  const methods = useForm<PassDealFormViewModel>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    async (data: PassDealFormViewModel) => {
      const { passComments, stageComments } = fromMissVMToDealDM(data);
      setLoading(true);
      await handleMissed(deal, stageComments ?? '', passComments ?? null);
      setLoading(false);
      next?.();
      onClose();
    },
    [deal, handleMissed, next, onClose]
  );

  return (
    <FormProvider {...methods}>
      <FormFieldsContainer>
        <MissDealFields schema={schema} />
        <StickyFormButtons
          onSubmit={methods.handleSubmit(onSubmit)}
          onCancel={onClose}
          style={{ padding: '0.5rem 0 2rem' }}
          submitLabel={'Move to Missed'}
          loading={loading}
        />
      </FormFieldsContainer>
    </FormProvider>
  );
}

function MissDealFields({ schema }: { schema: ObjectSchema<PassDealFormViewModel> }) {
  const formFields = schemaToFormFields(schema);
  const form = createFormFromFieldsArray(formFields);
  return <FormFactoryWithStandardLayout form={form} />;
}
